(function () {
  'use strict';

  var drawer = document.querySelector('[data-customise-drawer]');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('customise-drawer--open');
    document.body.style.overflow = 'hidden';
    drawer.dispatchEvent(new CustomEvent('customise:drawer:open'));
  }

  function closeDrawer() {
    drawer.classList.remove('customise-drawer--open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-customise-drawer-open]')) openDrawer();
  });

  var closeBtn = drawer.querySelector('[data-customise-drawer-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('customise-drawer--open')) closeDrawer();
  });

  var SHOP_DOMAIN = drawer.dataset.shopDomain;
  var STOREFRONT_TOKEN = drawer.dataset.storefrontToken;
  var SKU = drawer.dataset.sku;
  var contentLoaded = false;

  function graphqlFetch(queryString, cursor) {
    var query = 'query getAllFilteredProducts($cursor: String) {' +
      ' products(first: 250, after: $cursor, query: "' + queryString + '") {' +
      '   edges { cursor node {' +
      '     id title handle productType tags' +
      '     description' +
      '     featuredImage { url altText }' +
      '     priceRange { minVariantPrice { amount currencyCode } }' +
      '     variants(first: 1) { edges { node { id } } }' +
      '     options { name values }' +
      '   } }' +
      '   pageInfo { hasNextPage }' +
      ' } }';

    return fetch('https://' + SHOP_DOMAIN + '/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query: query, variables: { cursor: cursor } }),
    }).then(function (res) { return res.json(); });
  }

  function fetchAllProducts(queryString) {
    var allProducts = [];
    function fetchPage(cursor) {
      return graphqlFetch(queryString, cursor).then(function (json) {
        var products = json.data.products;
        allProducts = allProducts.concat(products.edges.map(function (e) { return e.node; }));
        if (products.pageInfo.hasNextPage) {
          var nextCursor = products.edges[products.edges.length - 1].cursor;
          return fetchPage(nextCursor);
        }
        return allProducts;
      });
    }
    return fetchPage(null);
  }

  function formatPrice(amount, currencyCode) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(parseFloat(amount));
  }

  function renderSwatches(product) {
    var colorOption = (product.options || []).filter(function (o) {
      return o.name === 'Color' || o.name === 'Colour';
    })[0];
    if (!colorOption) return '';
    var dots = colorOption.values.map(function (v) {
      return '<span class="customise-drawer__swatch" style="background-color: ' + v.toLowerCase() + '" title="' + v + '"></span>';
    }).join('');
    return '<div class="customise-drawer__row-swatches">' + dots + '</div>';
  }

  function getTypeValues(product) {
    return (product.tags || [])
      .filter(function (t) { return t.indexOf('Type_') === 0; })
      .map(function (t) { return t.slice('Type_'.length); });
  }

  function renderRow(product) {
    var price = formatPrice(product.priceRange.minVariantPrice.amount, product.priceRange.minVariantPrice.currencyCode);
    var variantEdge = product.variants.edges[0];
    var variantId = variantEdge ? variantEdge.node.id.split('/').pop() : '';
    var image = product.featuredImage ? product.featuredImage.url : '';
    var alt = product.featuredImage ? (product.featuredImage.altText || product.title) : product.title;
    var rowType = getTypeValues(product).join('|');

    return (
      '<div class="customise-drawer__row" data-row-type="' + rowType + '">' +
        '<img class="customise-drawer__row-image" src="' + image + '" alt="' + alt + '" loading="lazy" width="115" height="115">' +
        '<div class="customise-drawer__row-info">' +
          '<div class="customise-drawer__row-title">' + product.title + '</div>' +
          '<p class="customise-drawer__row-desc">' + (product.description || '') + '</p>' +
          '<div class="customise-drawer__row-price">' + price + '</div>' +
          renderSwatches(product) +
        '</div>' +
        '<button class="customise-drawer__add" type="button" data-add-variant="' + variantId + '"' + (variantId ? '' : ' disabled') + '>ADD</button>' +
      '</div>'
    );
  }

  function derivePillValues(products) {
    var counts = {};
    products.forEach(function (p) {
      getTypeValues(p).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
    });
    return Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
  }

  function applyPillFilter(groupName, value) {
    var list = drawer.querySelector('[data-customise-list="' + groupName + '"]');
    list.querySelectorAll('[data-row-type]').forEach(function (row) {
      var types = row.dataset.rowType ? row.dataset.rowType.split('|') : [];
      row.hidden = types.indexOf(value) === -1;
    });
  }

  function renderPills(groupName, values) {
    var filtersWrap = drawer.querySelector('[data-customise-filters="' + groupName + '"]');
    var pillsWrap = drawer.querySelector('[data-customise-pills="' + groupName + '"]');
    if (!values.length) {
      filtersWrap.hidden = true;
      return;
    }
    pillsWrap.innerHTML = values.map(function (v, i) {
      return '<button class="customise-drawer__pill' + (i === 0 ? ' customise-drawer__pill--active' : '') + '" type="button" data-pill-value="' + v + '">' + v + '</button>';
    }).join('');
    filtersWrap.hidden = false;
    pillsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pill-value]');
      if (!btn) return;
      pillsWrap.querySelectorAll('.customise-drawer__pill').forEach(function (p) { p.classList.remove('customise-drawer__pill--active'); });
      btn.classList.add('customise-drawer__pill--active');
      applyPillFilter(groupName, btn.dataset.pillValue);
    });
    applyPillFilter(groupName, values[0]);
  }

  function renderGroup(groupName, products) {
    if (!products.length) return;
    var section = drawer.querySelector('[data-customise-group="' + groupName + '"]');
    var list = drawer.querySelector('[data-customise-list="' + groupName + '"]');
    list.innerHTML = products.map(renderRow).join('');
    renderPills(groupName, derivePillValues(products));
    section.hidden = false;
  }

  function loadContent() {
    if (!SKU) return;
    var mountsQuery = 'product_type:Mount AND tag:' + SKU;
    var accessoriesQuery = '(product_type:Accessory OR product_type:Cover OR product_type:Rack OR product_type:Stabilizer OR product_type:Umbrella) AND tag:' + SKU;
    fetchAllProducts(mountsQuery).then(function (products) { renderGroup('mounts', products); });
    fetchAllProducts(accessoriesQuery).then(function (products) { renderGroup('accessories', products); });
  }

  drawer.addEventListener('customise:drawer:open', function () {
    if (contentLoaded) return;
    contentLoaded = true;
    loadContent();
  });

  // Cart popup: mirrors the standard "added to cart" experience used
  // elsewhere on the PDP (snippets/cart-popup.liquid), driven independently
  // of theme.js's theme.Product instance since this drawer isn't a product form.
  var cartPopupWrapper = document.querySelector('[data-cart-popup-wrapper]');
  var cartPopup = document.querySelector('[data-cart-popup]');
  var cartPopupTitle = document.querySelector('[data-cart-popup-title]');
  var cartPopupQuantity = document.querySelector('[data-cart-popup-quantity]');
  var cartPopupQuantityLabel = document.querySelector('[data-cart-popup-quantity-label]');
  var cartPopupClose = document.querySelector('[data-cart-popup-close]');
  var cartPopupDismiss = document.querySelector('[data-cart-popup-dismiss]');
  var cartPopupImageWrapper = document.querySelector('[data-cart-popup-image-wrapper]');
  var cartPopupProductDetails = document.querySelector('[data-cart-popup-product-details]');
  var cartPopupCartQuantity = document.querySelector('[data-cart-popup-cart-quantity]');
  var cartPopupPreviouslyFocused = null;

  function getVariantOptionListHTML(options) {
    return options.map(function (o) {
      return '<li class="product-details__item product-details__item--variant-option">' + o.name + ': ' + o.value + '</li>';
    }).join('');
  }

  function getPropertyListHTML(properties) {
    return Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_' && String(properties[key]).length !== 0;
    }).map(function (key) {
      return '<li class="product-details__item product-details__item--property"><span class="product-details__property-label">' + key + ': </span>' + properties[key] + '</li>';
    }).join('');
  }

  function hideCartPopup(event) {
    if (!cartPopupWrapper) return;
    theme.Helpers.prepareTransition(cartPopupWrapper);
    cartPopupWrapper.classList.add('cart-popup-wrapper--hidden');

    var image = cartPopupImageWrapper ? cartPopupImageWrapper.querySelector('[data-cart-popup-image]') : null;
    if (image) image.remove();
    if (cartPopupImageWrapper) cartPopupImageWrapper.setAttribute('data-image-loading-animation', '');

    slate.a11y.removeTrapFocus({ container: cartPopupWrapper, namespace: 'cartPopupFocus' });
    if (event && event.detail === 0 && cartPopupPreviouslyFocused) cartPopupPreviouslyFocused.focus();

    document.removeEventListener('keyup', cartPopupKeyupHandler);
    document.removeEventListener('click', cartPopupBodyClickHandler);
  }

  function cartPopupKeyupHandler(event) {
    if (event.key === 'Escape') hideCartPopup(event);
  }

  function cartPopupBodyClickHandler(event) {
    var target = event.target;
    if (target !== cartPopupWrapper && !target.closest('[data-cart-popup]')) hideCartPopup(event);
  }

  function showCartPopup(item, cartItemCount) {
    if (!cartPopupWrapper) return;

    cartPopupTitle.textContent = item.product_title;
    cartPopupQuantity.textContent = 1;
    cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace('[count]', 1);

    if (item.featured_image) {
      cartPopupImageWrapper.classList.remove('hide');
      var sizedImageUrl = theme.Images.getSizedImageUrl(item.featured_image.url, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = item.featured_image.alt || item.product_title;
      image.classList.add('cart-popup-item__image');
      image.setAttribute('data-cart-popup-image', '');
      image.onload = function () {
        cartPopupImageWrapper.removeAttribute('data-image-loading-animation');
        cartPopupImageWrapper.append(image);
      };
    } else {
      cartPopupImageWrapper.classList.add('hide');
    }

    var detailsHTML = '';
    if (!item.product_has_only_default_variant) detailsHTML += getVariantOptionListHTML(item.options_with_values);
    if (item.properties && Object.keys(item.properties).length) detailsHTML += getPropertyListHTML(item.properties);
    cartPopupProductDetails.innerHTML = detailsHTML;
    cartPopupProductDetails.toggleAttribute('hidden', detailsHTML.length === 0);

    if (cartPopupCartQuantity) cartPopupCartQuantity.textContent = cartItemCount;

    theme.Helpers.prepareTransition(cartPopupWrapper);
    cartPopupWrapper.classList.remove('cart-popup-wrapper--hidden');

    document.addEventListener('keyup', cartPopupKeyupHandler);
    document.addEventListener('click', cartPopupBodyClickHandler);
    slate.a11y.trapFocus({ container: cartPopupWrapper, elementToFocus: cartPopup, namespace: 'cartPopupFocus' });
  }

  if (cartPopupClose) cartPopupClose.addEventListener('click', hideCartPopup);
  if (cartPopupDismiss) cartPopupDismiss.addEventListener('click', hideCartPopup);

  function addToCart(variantId, buttonEl) {
    buttonEl.disabled = true;
    cartPopupPreviouslyFocused = document.activeElement;
    var addedItem;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: 'id=' + variantId + '&quantity=1',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function (item) {
        addedItem = item;
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < countEls.length; i++) countEls[i].textContent = cart.item_count;
        var bubbleEls = document.querySelectorAll('[data-cart-count-bubble]');
        for (var j = 0; j < bubbleEls.length; j++) bubbleEls[j].classList.toggle('hide', cart.item_count === 0);

        buttonEl.disabled = false;
        closeDrawer();
        showCartPopup(addedItem, cart.item_count);
      })
      .catch(function () {
        buttonEl.disabled = false;
      });
  }

  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn || btn.disabled || !btn.dataset.addVariant) return;
    addToCart(btn.dataset.addVariant, btn);
  });
})();
